/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      this.checkout_button = this.parentNode.querySelector('.button.checkout-button');

      if (this.terms_checkbox && this.checkout_button) {
        this.terms_checkbox.setCustomValidity(''); // Checkbox is optional
        this.checkout_button.addEventListener('click', () => {
          // Set cart attribute based on the checkbox state
          const attributeValue = this.terms_checkbox.checked ? "Yes" : "No";
          this.updateCartAttribute(attributeValue);
        });
      }
    }

    updateCartAttribute(attributeValue) {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            "Authority to Leave": attributeValue
          }
        })
      })
        .then((response) => {
          if (!response.ok) {
            console.error('Failed to update cart attribute');
          }
        })
        .catch((error) => {
          console.error('Error updating cart attribute:', error);
        });
    }
  }

  customElements.define('terms-checkbox', TermsCheckbox);
}
